'use strict';

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find('input, select').each(function () {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
            }
        });
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    const $form = $(form);

    $form.find('.invalid-feedback').empty();
    $form.find('.form-control.is-invalid').removeClass('is-invalid');
}

/**
 * Validates phone input against country-specific regex from data-phone-pattern
 * @param {HTMLElement} input - Phone input element
 * @returns {void}
 */
function validatePhone(input) {
    var $input = $(input);
    var $formGroup = $input.parents('.form-group');
    var pattern = $input.data('phone-pattern');
    if (!pattern || !input.value) {
        input.setCustomValidity('');
        $input.removeClass('is-invalid');
        $formGroup.find('.invalid-feedback').empty();
        return;
    }
    var regex = new RegExp(pattern);
    if (!regex.test(input.value)) {
        var message = $input.data('pattern-mismatch') || 'Invalid phone number';
        input.setCustomValidity(message);
        $input.addClass('is-invalid');
        $formGroup.find('.invalid-feedback').text(message);
    } else {
        input.setCustomValidity('');
        $input.removeClass('is-invalid');
        $formGroup.find('.invalid-feedback').empty();
    }
}

module.exports = {
    invalid: function () {
        $('form input, form select').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').find('.invalid-feedback')
                    .text(validationMessage);
            }
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            return validateForm.call(this, e);
        });
    },

    phoneValidation: function () {
        $('input[data-phone-pattern]').on('focus', function () {
            var prefix = $(this).data('phone-prefix');
            if (prefix && !this.value) {
                this.value = prefix;
            }
        }).on('input', function () {
            var prefix = $(this).data('phone-prefix');
            // Strip spaces from phone input
            var cursorPos = this.selectionStart;
            var stripped = this.value.replace(/\s/g, '');
            if (stripped !== this.value) {
                var spacesBeforeCursor = (this.value.substring(0, cursorPos).match(/\s/g) || []).length;
                this.value = stripped;
                this.setSelectionRange(cursorPos - spacesBeforeCursor, cursorPos - spacesBeforeCursor);
            }
            if (prefix && !this.value.startsWith(prefix)) {
                this.value = prefix;
                this.setSelectionRange(prefix.length, prefix.length);
            }
        }).on('keydown', function (e) {
            var prefix = $(this).data('phone-prefix');
            if (!prefix) return;
            var selStart = this.selectionStart;
            var selEnd = this.selectionEnd;
            // Block backspace/delete if it would eat into the prefix
            if (e.key === 'Backspace' && selStart <= prefix.length && selStart === selEnd) {
                e.preventDefault();
            }
            if (e.key === 'Delete' && selStart < prefix.length) {
                e.preventDefault();
            }
        });
    },

    buttonClick: function () {
        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'));
            // validate phone fields before submit
            $(this).parents('form').find('input[data-phone-pattern]').each(function () {
                validatePhone(this);
            });
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: clearForm
    }
};
